import React, { useContext, useState, useEffect, useRef } from 'react';
import classes from './index.module.scss';
import ScheduleOptions from './ScheduleOptions';
import moment from 'moment';
import Select from '../UI/Select';
import TextInput from '../UI/TextInput';
import TextArea from '../UI/TextArea';
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { convertFromRaw, EditorState, convertToRaw } from "draft-js";
import localization from "./config/localization";
import toolbar from "./config/toolbar";
import "./styles/style.css";
import CustomComponent from "./CustomComponent";
import CustomSMSTextArea from "./CustomSMSTextArea";
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { scheduleEmailsPost, scheduleSmsPost, exmTemplateKeys } from '../../api';
import { useForm } from 'react-hook-form';
import { store } from 'react-notifications-component';
import { useHistory } from 'react-router-dom';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import SendTestEmail from './SendTestEmail';
import { HashLink } from 'react-router-hash-link';
import { UserContext } from 'context/User';

const ScheduleBox = ({ type, templateKeys, handleDefaultStatusCodes, setLoading }) => {

    const { register, handleSubmit, errors } = useForm();
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [scheduledFrequency, setScheduledFrequency] = useState('ONE_TIME');
    const [scheduledInterval, setScheduledInterval] = useState('1');
    const [scheduledSendTime, setScheduledSendTime] = useState('');
    const [scheduledSubject, setScheduledSubject] = useState('');
    const [showTestModal, setShowTestModal] = useState(false);
    const [exmtemplateKeys, setExmTemplateKeys] = useState({});
    const userEmailValue = useContext(UserContext).user.email;
    const [userEmailField, setUserEmailField] = useState(userEmailValue);
    const userNameValue = useContext(UserContext).user.username;
    const submitRef = useRef(null);
    const history = useHistory();
    const link = type === 'email' && '/schedule-emails' || type === 'sms' && '/schedule-sms';

    const onChangeHandler = (value) => {
        setScheduledFrequency(value.value)
    };
    const handleMultiChange = (value) => {
        onChangeHandler(value);
        document.activeElement.blur()
    }
    const handleApply = (event, picker) => {
        picker.element.val(
            picker.startDate.format('MM/DD/YYYY hh:mm A')
        );
        setScheduledSendTime(picker.startDate.format('MM/DD/YYYY hh:mm A'))
        // new Date(picker.startDate.format('MM/DD/YYYY hh:mm A')).toISOString()
    };
    const dateRangeRef = useRef();
    const handleCancel = (event, picker) => {
        dateRangeRef.current.ref.value = "";
        setScheduledSendTime('');
    };

    const somethingWentWrongNotice = (operationName) => {
        store.addNotification({
            title: operationName,
            message: "This field is required",
            type: "danger",
            container: "top-right",
            animationIn: ["animate__animated", "animate__slideInRight"],
            animationOut: ["animate__animated", "animate__slideOutRight"],
            dismiss: {
                duration: 5000,
                onScreen: false
            }
        });
    };
    const replyMessageNotice = (title, type, message) => {
        store.addNotification({
            title: title,
            message: message ? message :`Your scheduled ${type} has been created.`,
            type: "success",
            container: "top-right",
            animationIn: ["animate__animated", "animate__slideInRight"],
            animationOut: ["animate__animated", "animate__slideOutRight"],
            dismiss: {
                duration: 5000,
                onScreen: false
            }
        });
    }
    const onSubmit = data => {
        setLoading(true);

        const body = {
            scheduled_send_time: new Date(scheduledSendTime).toISOString(),
            recurrence_frequency: scheduledFrequency,
            // scheduled_send_time: moment(new Date()).toISOString(true),
            ...data
        }
        delete body.scheduled_send_time_temp;
        body.recurrence_interval = parseInt(scheduledInterval)
        if (body.body === '<p></p>' || body.body === '<p></p>\n') {
            setLoading(false)
            somethingWentWrongNotice("Please fill out Body field")
        }
        else {
            if (type === 'email') {
                scheduleEmailsPost("email", body)
                    .then(() => {
                        // handleClose();
                        setLoading(false);
                        replyMessageNotice("Success!", type)
                        setTimeout(() => history.push(link), 2000);
                    })
                    .catch(error => {
                        handleDefaultStatusCodes(error.response.status);
                        // handleClose();
                    });
            }
            if (type === 'sms') {
                scheduleSmsPost("sms", body)
                    .then(() => {
                        // handleClose();
                        setLoading(false);
                        replyMessageNotice("Success!", type)
                        setTimeout(() => history.push(link), 2000);
                    })
                    .catch(error => {
                        handleDefaultStatusCodes(error.response.status);
                        // handleClose();
                    });
            }

        }


    }
/* Start Send Test Email */
const onChangeEmailField = (value) => {
    setUserEmailField(value)
};
const onSendTestEmail = (e) => {
    setShowTestModal(true);
    e.preventDefault();
  }
  const handleClose = () => {
    setShowTestModal(false);
}

const templateKeysExmRequest = () => {
    exmTemplateKeys()
        .then(response => {
        let temp_data = response.data.email
        temp_data.user_email = userEmailValue
        temp_data.user_name = userNameValue
        setExmTemplateKeys(response.data.email);
        setIsMounted(true)
        setLoading(false);
        })
        .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
        })
}

const handleChangeInputs = (name, event) => {
    // Create a copy of the addresses object using spread syntax
    const updatedTemplateKeys = { ...exmtemplateKeys };
    // Update the value for the specified name
    updatedTemplateKeys[name] = event.target.value;
    // Set the updated state
    setExmTemplateKeys(updatedTemplateKeys);
};


const [isMounted, setIsMounted] = useState(false)

useEffect(() => {
    templateKeysExmRequest()
    // setIsMounted(true)
    return () => {
        setIsMounted(false)
    }
}, [])
/* End Send Test Email */

    return (
        <div className={classes.Message_Box}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <fieldset>
                    <label htmlFor="template_title">Template Title</label>
                    <TextInput
                        name="template_title"
                        register={register()}
                        required={true}
                    />
                </fieldset>
                {(type === 'email') ?
                    <fieldset>
                        <label htmlFor="subject">Subject</label>
                        <TextInput
                            name="subject"
                            value={scheduledSubject}
                            onChange={(event) => setScheduledSubject(event.target.value)}
                            register={register()}
                            required={true}
                        />
                    </fieldset>
                : ''}
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <fieldset>
                        <label htmlFor="recurrence_frequency">Recurrence frequency</label>
                        <Select
                            handleMultiChange={handleMultiChange}
                            name="recurrence_frequency"
                            list={
                                [
                                    { value: "ONE_TIME", label: "Onetime" },
                                    { value: "DAY", label: "Daily" },
                                    { value: "WEEK", label: "Weekly" },
                                    { value: "MONTH", label: "Monthly" },
                                    { value: "YEAR", label: "Yearly" },
                                ]
                            }
                            styles="react-select-input-container"
                            prefixStyles="react-select-input"
                            indicator={false}
                            isSearchable={false}
                            isClear={false}
                            defaultValue={{ value: "ONE_TIME", label: "Onetime" }}
                        />
                    </fieldset>
                    <fieldset>
                        <label htmlFor="recurrence_interval">Recurrence interval</label>
                        <TextInput
                            type='number'
                            min="1"
                            name="recurrence_interval"
                            check={scheduledFrequency === 'ONE_TIME' ? false : true}
                            value={scheduledFrequency === 'ONE_TIME' ? '' : scheduledInterval}
                            onChange={(event) => setScheduledInterval(event.target.value)}
                            register={register()}
                            required={true}
                        />
                    </fieldset>
                    <fieldset>
                        <label htmlFor="scheduled_send_time">Scheduled Send Time</label>
                        <div className={`advanced-picker-wrap`}>
                            <DateRangePicker
                                ref={dateRangeRef}
                                initialSettings={{
                                    autoUpdateInput: true,
                                    minDate: moment(new Date()),
                                    singleDatePicker: true,
                                    startDate: moment(new Date()),
                                    locale: {
                                        cancelLabel: 'Clear',
                                        format: 'MM/DD/YYYY hh:mm A'
                                    },
                                    timePicker: true,
                                }}
                                onApply={(event, picker) => {
                                    handleApply(event, picker);
                                }}
                                onCancel={handleCancel}
                            >
                                <input
                                    style={{ paddingLeft: '10px' }}
                                    type="text"
                                    required={true}
                                    value={scheduledSendTime}
                                    onChange={(event) => setScheduledSendTime(event.target.value)}
                                    name='scheduled_send_time_temp'
                                    placeholder="MM/DD/YYYY hh:mm A"
                                />
                            </DateRangePicker>
                        </div>
                    </fieldset>
                </div>
                {type === "email" ?
                    <fieldset>
                        <div className='mb-5'>
                            <label htmlFor="subject">Body</label>
                            <Editor
                                editorState={editorState}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={setEditorState}
                                toolbar={toolbar}
                                toolbarCustomButtons={[<CustomComponent templateKey={templateKeys} type={type} />]}
                            />
                            <TextInput
                                type="hidden"
                                name="body"
                                register={register()}
                                value={`${draftToHtml(convertToRaw(editorState.getCurrentContent()))}`}
                            />
                        </div>
                    </fieldset>
                    :
                    <fieldset>
                        <label htmlFor="message">Body</label>
                        <CustomSMSTextArea templateKey={templateKeys} type={type} register={register} />
                    </fieldset>
                }
                <div className='mt-2'>
                    <ScheduleOptions
                        type={type}
                        submitRef={submitRef}
                        handleDefaultStatusCodes={handleDefaultStatusCodes}
                        setLoading={setLoading}
                    />
                </div>
            </form>
            {type === "email" ?
            <HashLink
                onClick={(e) => onSendTestEmail(e)}
                to='#'
                className="btnSizes transparentBtn mt-4"
                smooth
            >
                Send Test Email
            </HashLink>
            : ''}
            {isMounted && (showTestModal && <SendTestEmail userEmailField={userEmailField} onChangeEmailField={onChangeEmailField} replyMessageNotice={replyMessageNotice} template_keys_exp={exmtemplateKeys} handleChangeInputs={handleChangeInputs} handleDefaultStatusCodes={handleDefaultStatusCodes} setLoading={setLoading} showModal={showTestModal} handleClose={handleClose} />)}
        </div>
    )
}

export default ScheduleBox;